import { render, staticRenderFns } from "./Logistics_detail.vue?vue&type=template&id=4d5c34d5"
import script from "./Logistics_detail.vue?vue&type=script&lang=js"
export * from "./Logistics_detail.vue?vue&type=script&lang=js"
import style0 from "./Logistics_detail.vue?vue&type=style&index=0&id=4d5c34d5&prod&lang=less&scpoed=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports